<template>
    <div>
      <!-- Body -->
      <div class="body">
        <div>
          <themed-table 
            :headers="this.transformedHeaders" 
            :data="transformedData" 
            :pagination="{
                perPage: this.bedManagerService.devices.query.limit,
                total: this.bedManagerService.devices.total
            }"
            :sortingEnabled=true 
            :filteringEnabled=false
            :paginationEnabled="this.bedManagerService.devices.total > this.bedManagerService.devices.query.limit" 
            :tenantSelected=currentTenant
            :tenantOptions=this.bedManagerService.tenants.data
            :syncSearchValues="currentQuery"
            :locationTreeSearchValue="this.bedManagerService.devices.searchValue"
            @paginationChange="(event) => {
                this.bedManagerService.devices.query.skip = this.bedManagerService.devices.query.limit * (event.page - 1);
                this.bedManagerService.devices.query = {...this.bedManagerService.devices.query};
            }"
            @areasChange="(event) => {
                this.bedManagerService.devices.searchValue = '';
                this.bedManagerService.devices.query.area = event;
                this.bedManagerService.devices.query = {...this.bedManagerService.devices.query};
                const item = this.bedManagerService.devices.headers.find((header) => header.key === 'poc');
                if (item && event && event.length) {
                  item.filterActive = true;
                } else if (item) item.filterActive = false;
                this.bedManagerService.devices.headers = [...this.bedManagerService.devices.headers];
            }"
            @locationTreeSearch="(event) => {
                this.bedManagerService.devices.searchValue = event;
            }"
            @searchChange="(event) => {
              const query = this.bedManagerService.devices.query;
              query.skip = 0; // Resets skip as the search params change
              let newTenant = null;
              Object.keys(event).forEach((key) => {
                const customHandlers = ['scope', 'deviceCount'];
                  if (!customHandlers.includes(key) && event[key]) query[key] = event[key];
                  else if (key === 'scope' && event[key] && this.bedManagerService.tenants.selected !== event[key]) newTenant = event[key];
                  else if (key === 'deviceCount' && event[key]) query['deviceId'] = event[key];
                  else delete query[key];
              })
              if (newTenant !== null) {
                Object.keys(query).forEach((prop) => this.bedManagerService.devices.query[prop] = query[prop]);
                this.bedManagerService.tenants.selected = newTenant;
                if (!newTenant) {
                  this.bedManagerService.devices.data = [];
                  this.bedManagerService.devices.total = 0;
                  this.bedManagerService.jobs.data = [];
                  this.bedManagerService.jobs.total = 0;
                }
              } else {
                this.bedManagerService.devices.query = {...query};
              }
            }"
            @tenantChange="(event) => {
              this.bedManagerService.tenants.selected = event;
              if (!event) {
                this.bedManagerService.devices.data = [];
                this.bedManagerService.devices.total = 0;
                this.bedManagerService.jobs.data = [];
                this.bedManagerService.jobs.total = 0;
              }
            }"
            @sortingChange="(event) => {
              if (event.type === 'firmwareVersionFormatted') {
                this.bedManagerService.devices.query = { ...this.bedManagerService.devices.query, sortProperty: 'firmwareVersion', sortDirection: event.direction };
              } else if (event.type === 'status') {
                this.bedManagerService.devices.query = { ...this.bedManagerService.devices.query, sortProperty: 'isOffline', sortDirection: event.direction };
              } else if (event.type === 'serial') {
                this.bedManagerService.devices.query = { ...this.bedManagerService.devices.query, sortProperty: 'properties.bedData.PropertiesResponse.GatewayMACAddress', sortDirection: event.direction };
              } else {
                this.bedManagerService.devices.query = { ...this.bedManagerService.devices.query, sortProperty: event.type, sortDirection: event.direction };
              }
            }"
            @rowClick="(event) => {
              setDevice(event);
            }"
            :addItem="{ label: 'Job', element: CreateJobs }"
            ></themed-table>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Vue from "vue";
  import VueToast from "vue-toast-notification";
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  import ThemedTable from "../../../shared/careai/components/ThemedTable.vue";
  import BedManagerService from "../BedManager.service";
  import CreateJobs from "../jobs/CreateJobs.vue";

  const moment = require("moment");
  
  Vue.use(VueToast);
  Vue.use(Loading);
  Vue.component('themed-table', ThemedTable);
  
  export default {
    name: "DeviceAttributes",
    components: { },
    data() {
      return {
        console: console,
        moment: moment,
        CreateJobs: CreateJobs,
        
        // Singleton Pattern Service
        // Contains State and API Requests
        bedManagerService: BedManagerService,
      };
    },
    computed: {
      transformedHeaders() {
        return this.bedManagerService.devices.headers;
      },
      transformedData() {
        return this.bedManagerService.devices.data.map((item) => {
          item.locationId = item.location;
          item.unitId = item.unit;
          item.areaId = item.area;
          item.serial = item.properties && item.properties.bedData && item.properties.bedData.PropertiesResponse && item.properties.bedData.PropertiesResponse.GatewayMACAddress;
          if (item.lastHealthReported) {
            item.lastHealthReported = moment(item.lastHealthReported).format("MMMM Do, YYYY [at] h:mm A");
          }
          if (item.registeredOn) {
            item.registeredOn = moment(item.registeredOn).format("MMMM Do, YYYY [at] h:mm A");
          }
          const deviceTaskObj = item.latestCompletedJob && Array.isArray(item.latestCompletedJob.devices) ? item.latestCompletedJob.devices.find((device) => device.id === item.deviceId) : null;
          const latestTasks = deviceTaskObj && Array.isArray(deviceTaskObj.tasks) ? deviceTaskObj.tasks : [];
          const latestCompletedTaskIndex = latestTasks.map(o => o['status']).lastIndexOf('GatewayUpdateSuccess');
          item.firmwareVersionFormatted = `<div style="display: flex; flex-direction: column;">
            ${item.latestCompletedJob && Array.isArray(item.latestCompletedJob.tasks) && Number.isInteger(latestCompletedTaskIndex) ? 
             `<div><b>Latest Package</b>: ${item.latestCompletedJob.tasks[latestCompletedTaskIndex].metadata.packageVersion}</div>`
            : ""}
          `;
          if (item.properties) {
            if (item && item.properties && item.properties.version) {
              Object.keys(item.properties.version).forEach((key) => {
                item.firmwareVersionFormatted += `<div style="text-wrap: wrap;"><b>${key}</b>: ${item.properties.version[key]}</div>`;
              });
            }
          }
          item.firmwareVersionFormatted += '</div>';
          if (item.deviceId) {
            item.status = `<div data-toggle="tooltip" title="Device ${item.isOffline ? 'offline' : 'online'}." class="${item.isOffline ? 'isNotReady' : 'isReady'}"></div>`;
          }
          item.location = item.locationName || '';
          item.unit = item.unitName || '';
          item.area = item.areaName || '';
          item.poc = `${item.areaName ? `${item.areaName} / ` : ''}${item.unitName ? `${item.unitName} / ` : ''} ${item.locationName || ''}`;

          return item;
        });
      },
      currentDMConfiguration() {
        if (this.bedManagerService.configuration) {
            return this.bedManagerService.configuration;
        }
        return null;
      },
      currentQuery() {
        if (this.bedManagerService.devices.query) {
            return this.bedManagerService.devices.query;
        }
        return null;
      },
      currentTenant() {
        if (this.bedManagerService.tenants) {
            return this.bedManagerService.tenants.selected;
        }
        return null;
      },
      currentConfiguration() {
        if (this.currentDMConfiguration && this.currentDMConfiguration.tasks) {
            return this.currentDMConfiguration.tasks;
        }
        return null;
      },
    },
    watch: {
        currentQuery(newQuery, oldQuery) {
          this.bedManagerService.fetchDevices();
        },
        currentTenant() {
          this.bedManagerService.fetchDevices();
        }, 
        currentConfiguration() {
          this.bedManagerService.devices.query = { ...this.bedManagerService.devices.query };
        }
    },
    mounted() {
      if (!this.bedManagerService.devices.data.length) this.bedManagerService.fetchDevices();
    },
    unmounted() {},
    methods: {
      setDevice(event) {
        this.bedManagerService.selectedDevice = { ...this.bedManagerService.selectedDevice, id: null, data: [] }; 
        setTimeout(() => {
          this.bedManagerService.selectedDevice = { ...this.bedManagerService.selectedDevice, id: event.deviceId, data: []};
          setTimeout(() => this.bedManagerService.tabIndex = 2, 15);
          if (this.bedManagerService.selectedJob.data.length) {
            setTimeout(() => this.bedManagerService.tabIndex = 4, 25);
          } else setTimeout(() => this.bedManagerService.tabIndex = 3, 25);
        }, 1000)
      }, 
      filterJson(data, search) {
        const lowerSearch = search.toLowerCase();
        if (Array.isArray(data)) {
            const filteredArray = data
            .map(item => this.filterJson(item, search))
            .filter(item =>
                item !== undefined &&
                (typeof item !== 'object' ||
                (Array.isArray(item) ? item.length : Object.keys(item).length))
            );
            return filteredArray.length ? filteredArray : undefined;
        } else if (data && typeof data === 'object') {
            const result = {};
            for (const key in data) {
                if (!data.hasOwnProperty(key)) continue;
                const value = data[key];
                const keyMatches = key.toLowerCase().includes(lowerSearch);
                if (keyMatches) {
                    result[key] = value;
                } else if (value !== null && typeof value === 'object') {
                    const filteredValue = this.filterJson(value, search);
                    if (
                    filteredValue !== undefined &&
                    (Array.isArray(filteredValue)
                        ? filteredValue.length
                        : Object.keys(filteredValue).length)
                    ) {
                        result[key] = filteredValue;
                    }
                } else {
                    const strValue = String(value).toLowerCase();
                    if (strValue.includes(lowerSearch)) {
                        result[key] = value;
                    }
                }
            }
            return Object.keys(result).length ? result : undefined;
        } else {
            return String(data).toLowerCase().includes(lowerSearch) ? data : undefined;
        }
      }
    },
  };
  </script>
  
  <!-- Header Styles -->
  <style lang="scss" scoped>
    .page-header {
      &__flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
  
      &__statistics {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
  
      &__statistics-item {
        font-size: .7em;
        display: flex;
        flex-direction: column;
      }
    }

    .body {
        &__inner {
            padding: 15px;
        }
    }
  </style>  
  
  <style>
  ::-webkit-scrollbar {
    width: 6px; 
    height: 6px;
  }
  </style>
  